// extracted by mini-css-extract-plugin
module.exports = {"dateField":"DatePicker_dateField__1r1Ku","title":"DatePicker_title__DRemr","date":"DatePicker_date__3o9T_","dash":"DatePicker_dash__208Hf","calendar":"DatePicker_calendar__36R7G"};